<template>
  <L7Marker
    class="w-[68px] h-17"
    :style="{
      position: 'relative',
      width: '68px',
      height: `68px`,
    }"
    :lnglat="lnglat"
  >
    <div
      class="el-popover el-popper absolute min-w-[218px] transform !right-0 translate-x-full !top-1/2 -translate-y-1/2 -mr-5"
      x-placement="right"
    >
      <div class="popper__arrow !top-1/2 transform -translate-y-1/2" />
      <div>
        <div class="flex items-center">
          <el-image
            class="w-[68px] h-6"
            fit="cover"
            :src="selectedCruise.logo"
          />
          <button
            v-if="showDetailBtn"
            class="text-primary ml-auto text-sm"
            @click="onDetail"
          >
            <span>查看</span>
            <i class="el-icon-arrow-right" />
          </button>
          <button v-if="showClose" :class="$style.closeBtn" @click="$emit('close')">
            <i class="el-icon-close" />
          </button>
        </div>
        <div class="text-dark font-semibold mt-2 flex items-center">
          <el-image
            v-if="selectedCruise.flag"
            class="w-6 h-4 mr-2"
            fit="cover"
            :src="selectedCruise.flag"
          />
          <span class="whitespace-nowrap">{{ selectedCruise.name }}</span>
        </div>
        <div class="text-xxs fomt-semibold mt-1 whitespace-nowrap">
          {{ selectedCruise.en_name }}
        </div>
        <div class="mt-1 text-secondary text-xxs">
          航行状态：{{ selectedCruise.navistatus_label }}
        </div>
        <div class="mt-1 text-secondary text-xxs">
          更新时间：{{ selectedCruise.update_time }}
        </div>
      </div>
    </div>

    <img
      class="w-[68px] h-17 !block mask"
      src="~@/assets/img/cruise-map/icon-ship-mask.png"
    />
  </L7Marker>
</template>
<script>
import defineAsyncComponent from "~/utils/defineAsyncComponent";

export default {
  name: "cruise-map-mask",
  emits: ["close"],
  components: {
    L7Marker: defineAsyncComponent(() =>
      import("@/components/l7-map/marker.vue")
    ),
  },
  props: {
    lnglat: {
      type: Array,
      default: () => [],
    },
    showPopover: Boolean,
    showClose: {
      type: Boolean,
      default: true,
    },
    showDetailBtn: {
      type: Boolean,
      default: true,
    },
    selectedCruise: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },

  methods: {
    onDetail() {
      // console.log('on detail')
      if (!this.showDetailBtn) {
        return;
      }
      const { href } = this.$router.resolve({
        name: "company-cruise-cruiseId",
        params: {
          cruiseId: this.selectedCruise.id,
        },
      });
      window.open(href, "_blank");
      // console.log(
      // 	this.$router.resolve({
      // 		name: "company-cruise-cruiseId",
      // 		params: {
      // 			cruiseId: this.selectedCruise.id
      // 		}
      // 	})
      // );
      // this.$router.push({
      // 	name: "cruise-map-detail",
      // 	query: {
      // 		id: this.selectedCruise.id
      // 	}
      // });
    },
  },
};
</script>
<style lang="scss" module>
.closeBtn {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 9999px;
  height: 1.75rem;
  position: absolute;
  right: -1rem;
  top: -1rem;
  width: 1.75rem;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
}
.closeBtn:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
</style>
